import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import empty from '@static/image/empty.png';

import Color from '@tool/color';

interface IProps {
  margin?: string;
  padding?: string;
  className?: string;
  height?: string;
}
interface IState {}

const Empty = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { margin, padding, className, height } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className={['empty-101', className].join(' ')}
      style={{
        margin: margin,
        padding: padding,
        minHeight: height ? height : '200px',
        flex: 1,
      }}>
      <img src={empty} alt="empty" />
      <span>暂无数据</span>
    </section>
  );
};

export default observer(Empty);
